export const amityToken = "d7a8b0dedcb87d11824170d254f8c3824d462142"
export default amityToken;